import { useQuery } from "@tanstack/react-query";
import { getStatus } from "api";

// eslint-disable-next-line
const useQueryStatus = (id: string, options?: any) => {
  return useQuery(["status", id], () => getStatus(id), options);
};

export default useQueryStatus;
